import { combineReducers } from 'redux';
import authoriseReducer from './authoriseReducer';
import confirmModalReducer from './confirmModalReducer';
import eftReducer from './eftReducer';
import { addPositionsReducer, installationReducer, setActiveInstallationReducer } from './installationReducer';
import { logInReducer } from './logInOutReducer';
import machineReducer from './machineReducer';
import machineSaveReducer from './machineSaveReducer';
import operatorsReducer from './operatorsReducer';
import { collectionsFiltersReducer, kioskFiltersReducer, installationsFiltersReducer, settingsFiltersReducer, transactionsFiltersReducer, sessionsFiltersReducer, LiveFloorViewerFiltersReducer, analysisFiltersReducer } from './organisationDirectoryReducer';
import organisationReducer from './organisationReducer';
import organisationsReducer from './organisationsReducer';
import passwordModalReducer from './passwordModalReducer';
import removeAssetReducer from './removeAssetReducer';
import searchTermReducer from './searchTermReducer';
import successAlertReducer from './successAlertReducer';
import collectionModalReducer from './collectionModalReducer';
import bankingCommentsModalReducer from './bankingCommentsModalReducer';
import siteVarianceHistoryModalReducer from './siteVarianceHistoryModalReducer';
import collectionBreakdownModalReducer from './collectionBreakdownModalReducer';
import { transactionAdjustReducer, transactionAuthoriseReducer, transactionsReducer, transactionsTicketsReducer, transactionsKioskReducer, transactionVoidReducer } from './transactionsReducer';
import kioskReducer from './kioskReducer';
import sessionsByCompanyReducer from './sessionsByCompanyReducer';
import LiveFloorViewerReducer from './liveFloorViewDetailsModalReducer';
import addCommentModalReducer from './addCommentModalReducer';
import newProfileModalReducer from './newProfileModalReducer';
import revenueModalReducer from './revenueModalReducer';
import varianceHistoryDetailsModalReducer from './varianceHistoryDetailsModalReducer';
import floatLevelSettingsModalReducer from './floatLevelSettingsModalReducer';
import sessionReducer from './sessionReducer';
import liveFloorViewDetailsModalReducer from './liveFloorViewDetailsModalReducer';
import promoAnalysisModalReducer from './promoAnalysisModalReducer';
import promoAnalysisDetailsModalReducer from './promoAnalysisDetailsModalReducer';
import siteDetailsModalReducer from './siteDetailsModalReducer';
import { analysisReducer } from './analysisViewReducer';
import installHistoryModalReducer from './installHistoryModalReducer';
import countDetailsModalReducer from './countDetailsModalReducer';
import viewCommentsModalReducer from './viewCommentsModalReducer';

const appReducer = combineReducers({
	// modals
	successAlert: successAlertReducer,
	passwordModal: passwordModalReducer,
	collectionModal: collectionModalReducer,
	collectionBreakdownModal: collectionBreakdownModalReducer,
	siteVarianceHistoryModal: siteVarianceHistoryModalReducer,
	confirmModal: confirmModalReducer,
	bankingCommentsModal: bankingCommentsModalReducer,
	addCommentModal: addCommentModalReducer,
	newProfileModal: newProfileModalReducer,
	revenueModal: revenueModalReducer,
	varianceHistoryDetailsModal: varianceHistoryDetailsModalReducer,
	floatLevelSettingsModal: floatLevelSettingsModalReducer,
	promoAnalysisModal: promoAnalysisModalReducer,
	promoAnalysisDetailsModal: promoAnalysisDetailsModalReducer,
	siteDetailsModal: siteDetailsModalReducer,
	installHistoryModal: installHistoryModalReducer,
	countDetailsModal: countDetailsModalReducer,
	viewCommentsModal: viewCommentsModalReducer,

	// filters
	installationsFilters: installationsFiltersReducer,
	settingsFilters: settingsFiltersReducer,	
	transactionsFilters: transactionsFiltersReducer,
	sessionsFilters: sessionsFiltersReducer,
	collectionsFilters: collectionsFiltersReducer,
	kioskFilters: kioskFiltersReducer,
	LiveFloorViewerFilters: LiveFloorViewerFiltersReducer,
	analysisFilters: analysisFiltersReducer,

	// other
	analysisView: analysisReducer,
	sessionsByCompany: sessionsByCompanyReducer,
	session: sessionReducer,
	positionsAdd: addPositionsReducer,
	operators: operatorsReducer,
	searchTerms: searchTermReducer,
	machine: machineReducer,
	machineSave: machineSaveReducer,
	eftUpdate: eftReducer,
	authorise: authoriseReducer,
	assetRemove: removeAssetReducer,
	logIn: logInReducer,
	activeInstallation: setActiveInstallationReducer,
	transactionAdjust: transactionAdjustReducer,
	transactionAuthorise: transactionAuthoriseReducer,
	transactionVoid: transactionVoidReducer,
	transactionsTickets: transactionsTicketsReducer,
	transactionsKiosk: transactionsKioskReducer,
	organisations: organisationsReducer,
	organisation: organisationReducer,
	installations: installationReducer,
	transactions: transactionsReducer,
	liveFloorViewDetailsModal: liveFloorViewDetailsModalReducer,
	kiosk: kioskReducer,
});

export default (state, action) => {
	if (action.type === 'CLEAR_REDUX')
		state = appReducer({}, {});

	return appReducer(state, action)
}